import { MessageSquare, Calculator } from 'lucide-react';
import { NotificationCenter } from '../notifications/NotificationCenter';
import { UserMenu } from '../ui/UserMenu';
import { CurrencyIndicator } from '../ui/CurrencyIndicator';
import { Avatar } from '../ui/Avatar';
import type { User } from '@auth0/auth0-react';

interface HeaderActionsProps {
  onToggleCalculator: () => void;
  onToggleChat: () => void;
  onToggleUserMenu: () => void;
  user: User | undefined;
  showUserMenu: boolean;
  onCloseUserMenu: () => void;
}

export function HeaderActions({
  onToggleCalculator,
  onToggleChat,
  onToggleUserMenu,
  user,
  showUserMenu,
  onCloseUserMenu
}: HeaderActionsProps) {
  return (
    <div className="flex items-center gap-4">
      <CurrencyIndicator className="hidden md:flex" />
      
      <button 
        onClick={onToggleCalculator}
        className="text-muted-foreground hover:text-foreground"
      >
        <Calculator className="h-5 w-5" />
      </button>
      
      <button 
        onClick={onToggleChat}
        className="text-muted-foreground hover:text-foreground"
      >
        <MessageSquare className="h-5 w-5" />
      </button>

      <NotificationCenter />

      <div className="relative">
        <button 
          onClick={onToggleUserMenu}
          className="flex items-center gap-2 text-muted-foreground hover:text-foreground"
        >
          <Avatar user={user} size="md" />
          <span className="hidden md:block">{user?.name}</span>
        </button>

        {showUserMenu && <UserMenu onClose={onCloseUserMenu} />}
      </div>
    </div>
  );
}